import styled from '@emotion/styled';

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-width: 1280px;
  padding: 14px;
  box-sizing: border-box;
  background-color: #000000;
`;

export const IntervieweeInfo = styled.div`
  overflow: hidden;
  display: -webkit-box;
  align-items: center;
  height: 29px;
  white-space: pre-wrap;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  margin: auto 0;
  width: 410px;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const InterviewersArea = styled.div`
  display: flex;
  gap: 2px;
  width: 410px;
  justify-content: right;
`;

export const VideoWrapper = styled.video`
  width: 80px;
  height: 60px;
  transform: rotateY(180deg);
  background: url('/img/background.png');
`;
